const ALL_LOCALES = {
  EN_CA: 'en-ca',
  EN_AU: 'en-au',
  EN_NZ: 'en-nz',
  EN_HK: 'en-hk',
  FR_CA: 'fr-ca',
  ZH_HK: 'zh-hk',
};

// Get enabled locales by filtering out disabled ones from the environment variable
const getEnabledLocales = () => {
  // Try to parse NEXT_PUBLIC_DISABLED_LOCALES as JSON array
  let disabledLocales = [];

  try {
    const disabledLocalesValue = process.env.NEXT_PUBLIC_DISABLED_LOCALES || '[]';
    disabledLocales = JSON.parse(disabledLocalesValue).map((locale) => locale.trim().toLowerCase());
  } catch (error) {
    console.error('Error parsing NEXT_PUBLIC_DISABLED_LOCALES:', error);
    // Fallback to empty array if parsing fails
    disabledLocales = [];
  }

  // Create a copy of all locales
  const enabledLocales = { ...ALL_LOCALES };

  // Remove disabled locales
  Object.entries(ALL_LOCALES).forEach(([key, value]) => {
    if (disabledLocales.includes(value.toLowerCase())) {
      delete enabledLocales[key];
    }
  });

  return enabledLocales;
};

const LOCALES = getEnabledLocales();

/** @type {import('next-i18n-router/dist/types').Config} */
const i18nConfig = {
  locales: Object.values(LOCALES),
  defaultLocale: LOCALES.EN_CA,
  localeDetector: false,
  serverSetCookie: 'never',
};

module.exports = i18nConfig;
module.exports.LOCALES = LOCALES;
